module.exports = __webpack_public_path__ + "static/media/sheep.63fbd835.PNG";